module.exports = __webpack_public_path__ + "media/images/emoticons/tm-6820e95f3b416e3d8f39ded12454c5b8.gif";